/**
 * Your JS
 */
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { initFaqs } from './faqs.js';
import { initPostFilters } from './post-filters.js';
import { initApps } from './apps.js';
import { initReadMore } from './read-more.js';

/**
 * Testimonials slider ([testimonials_slider] shortcode).
 * Navigation and pagination elements sit outside the slider, so they're found by the selectors in its data attributes.
 */
function initTestimonials(root = document) {
  root.querySelectorAll('.dmn-testimonials').forEach((el) => {
    if (el.swiper) return;

    const { prev, next, pagination } = el.dataset;
    const find = (selector) => (selector && document.querySelector(selector) ? selector : null);
    const prevEl = find(prev);
    const nextEl = find(next);
    const paginationEl = find(pagination);

    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 1.2,
      spaceBetween: 16,
      watchOverflow: true,
      breakpoints: {
        768: { spaceBetween: 30 },
      },
      navigation: prevEl || nextEl ? { prevEl, nextEl } : false,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
    });
  });
}

initTestimonials();
initFaqs();
initPostFilters();
initApps();
initReadMore();

// Elementor editor re-renders widgets without a page load.
const onElementorReady = () => {
  window.elementorFrontend.hooks.addAction('frontend/element_ready/shortcode.default', ($scope) => {
    initTestimonials($scope[0]);
    initFaqs($scope[0]);
    initPostFilters($scope[0]);
    initApps($scope[0]);
  });
};

if (window.elementorFrontend?.hooks) {
  onElementorReady();
} else if (window.jQuery) {
  window.jQuery(window).on('elementor/frontend/init', onElementorReady);
}
